// Laboratory documentation: https://product.hubteam.com/docs/laboratory/guides/coding-a-frontend-experiment.html

import { createClient } from 'laboratory-lib';
import portalIdParser from 'PortalIdParser';
import Raven from 'raven-js';
import experiments from '../../experiments.yaml';
import { getDeviceId, getUtk } from 'usage-tracker-core/common/defaultTrackers';
const identifiers = {
  portalId: portalIdParser.get(),
  other: getDeviceId(),
  utk: getUtk()
};
function buildLaboratoryClient() {
  try {
    return createClient({
      name: 'pricing-pages-client',
      quickFetchLabel: 'experiment-treatments',
      identifiers,
      experiments: experiments
    });
  } catch (quickFetchError) {
    Raven.captureException(quickFetchError, {
      level: 'warning'
    });
    try {
      return createClient({
        name: 'pricing-pages-client',
        identifiers,
        experiments: experiments
      });
    } catch (fallbackError) {
      Raven.captureException(fallbackError);
      throw fallbackError;
    }
  }
}
export const laboratoryClient = buildLaboratoryClient();
export const logExposure = treatmentKey => laboratoryClient.logExposure(treatmentKey);